// Constants.
import * as ArchiveConstants from 'constants/ArchiveConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  archive: {},
  errorMessage: '',
};

export default function config(state = initialState, action = {}) {
  switch (action.type) {
    case ArchiveConstants.LOAD_ARCHIVE_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ArchiveConstants.LOAD_ARCHIVE_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        archive: action.archive,
      };
    case ArchiveConstants.LOAD_ARCHIVE_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        archive: {},
        errorMessage: action.response,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        archive: {},
        errorMessage: '',
      };
    default:
      return state;
  }
}
